import React from 'react';
import PropTypes from 'prop-types';

export default class Detail extends React.PureComponent {
  render() {
    const {
      firstCreditRole,
      firstCreditPersonOrCompany,
      secondCreditRole,
      secondCreditPersonOrCompany,
      thirdCreditRole,
      thirdCreditPersonOrCompany,
      video,
      fullImageUrl,
      fullImageAlt,
      isLoading,
    } = this.props;

    return (
      <div className={`Detail ${
        isLoading ? 'Detail--loading' : ''
      }`}
      >
        <div className="Detail__container container">
          {fullImageUrl ? (
            <a
              href={fullImageUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="Detail__link"
            >
              <img
                src={fullImageUrl}
                alt={fullImageAlt}
                className="Detail__image"
              />
            </a>
          ) : (
            <div
              className="Detail__video container--embed"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: video }}
            />
          )}
          {(firstCreditRole && firstCreditPersonOrCompany)
          || (secondCreditRole && secondCreditPersonOrCompany)
          || (thirdCreditRole && thirdCreditPersonOrCompany) ? (
            <div className="Detail__information">
              {firstCreditRole && firstCreditPersonOrCompany && (
                <div className="Detail__credit">
                  <h2
                    className="Detail__role"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: firstCreditRole || 'Loading' }}
                  />
                  <p
                    className="Detail__person-or-company"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: firstCreditPersonOrCompany || 'Loading' }}
                  />
                </div>
              )}
              {secondCreditRole && secondCreditPersonOrCompany && (
                <div className="Detail__credit">
                  <h2
                    className="Detail__role"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: secondCreditRole || 'Loading' }}
                  />
                  <p
                    className="Detail__person-or-company"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: secondCreditPersonOrCompany || 'Loading' }}
                  />
                </div>
              )}
              {thirdCreditRole && thirdCreditPersonOrCompany && (
                <>
                  <div className="Detail__credit">
                    <h2
                      className="Detail__role"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: thirdCreditRole }}
                    />
                    <p
                      className="Detail__person-or-company"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: thirdCreditPersonOrCompany }}
                    />
                  </div>
                </>
              )}
            </div>
            ) : ''}
        </div>
      </div>
    );
  }
}

Detail.propTypes = {
  video: PropTypes.string,
  fullImageUrl: PropTypes.string,
  fullImageAlt: PropTypes.string,
  firstCreditRole: PropTypes.string,
  firstCreditPersonOrCompany: PropTypes.string,
  secondCreditRole: PropTypes.string,
  secondCreditPersonOrCompany: PropTypes.string,
  thirdCreditRole: PropTypes.string,
  thirdCreditPersonOrCompany: PropTypes.string,
  isLoading: PropTypes.bool,
};

Detail.defaultProps = {
  video: '',
  fullImageUrl: '',
  fullImageAlt: '',
  firstCreditRole: '',
  firstCreditPersonOrCompany: '',
  secondCreditRole: '',
  secondCreditPersonOrCompany: '',
  thirdCreditRole: '',
  thirdCreditPersonOrCompany: '',
  isLoading: false,
};
